import React, {
	useEffect
}from "react"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	useParams
}from "react-router-dom"
import {
	helpSectionActions
}from "../store/actions"
import "./style.css"

const OneHelp = () => {
	const params = useParams()
	const dispatch = useDispatch()
	const { help } = useSelector(state => state.helpSectionReducer)

	useEffect(() => {
		if ((/^\d+$/).test(params.id))
			getOneHelp({ id: params.id })
		return () => {
			dispatch(helpSectionActions.clear())
		}
	}, [])

	const getOneHelp = (values) => {
		dispatch(helpSectionActions.getOneHelp(values))
	}

	return (
		<div className="one-help-wrapper">
			<h2 className="one-help-title">
				{ help?.title }
			</h2>
			<div dangerouslySetInnerHTML={ { __html: help?.htmlText } }>
			</div>
		</div>
	)
}

export default OneHelp